import React                 from 'react';
import { connect }           from 'react-redux';
import { reduxForm,
         Field,
         formValueSelector } from 'redux-form';
import { TextField,
         Select,
         RadioLabels,
         Rating,
         Radio,
         Captcha }           from 'theme/Form';
import { required }          from 'theme/utils/validate';
import { options,
         agreements }        from 'theme/content';
import { getMosOptions }     from 'theme/content/mosOptions';

import './Form.sass';


export default connect(
  (state, props) => ({
    invited: formValueSelector(props.form)(state, 'invited'),
    serviceBranchValue: formValueSelector(props.form)(state, 'reviewerDetails.serviceBranch')
  })
)(reduxForm({
    enableReinitialize: true
})(
  ({handleSubmit, pristine, submitting, invited, submitFailed, invalid, openModal, profile, editDisabled, getAutocomplete, serviceBranchValue}) => {
    const isSpouse = serviceBranchValue === 'Spouse';
    return (
      <div className="InterviewReview__form">
        <h4>Applicant Experience</h4>
        <form onSubmit={handleSubmit}>
          <h6>Employer Details</h6>
          <Field
            name="employer"
            label="Company Name"
            required
            placeholder="Start typing..."
            component={Select}
            valueKey='id'
            labelKey='name'
            validate={required}
            creatable
            onNewOptionClick={openModal}
            disabled={editDisabled}
            getAutocomplete={getAutocomplete}
            async
          />
          <Field
            name="jobDetails.position"
            label="Position Title"
            required
            placeholder="e.g. Team Manager"
            component={TextField}
            validate={required}
          />
          <Field
            name="jobDetails.jobFunction"
            label="Functional Area"
            placeholder="e.g. General and Operations Managers"
            component={Select}
            options={options.functions}
            disabled={editDisabled}
          />
          <h6>Experience Overview</h6>
          <Field
            name="review.reviewTitle"
            label="Review Title"
            placeholder="e.g. All vets should apply here! Great experience!"
            className="block"
            required
            component={TextField}
            validate={required}
          />
          <Field
            name="review.reviewComments"
            label="Review Comments"
            className="block"
            placeholder="For review prompts, refer to 'Military specific questions' and 'General questions'. Please be as generous as you can with details. --------->"
            required
            componentType="textarea"
            component={TextField}
            validate={required}
          />
          <Field
            name="rating"
            label="Rate your experience"
            required
            validate={required}
            component={Rating}
            disabled={editDisabled}
          />
          <h6>Application & Interview Details</h6>
          <Field
            name="interviewDetails.yearInterviewed"
            label="Year Applied"
            component={Select}
            options={options.yearInterviewed}
            disabled={editDisabled}
          />
          <Field
            className="InterviewReview__formRadio"
            name="invited"
            label="I was invited to interview"
            component={Radio}
            mode="checkbox"
            disabled={editDisabled}
          />
          <Field
            name="interviewDetails.interviewSource"
            label="How did you get the interview?"
            className="block"
            placeholder="What was the main reason for getting your interview?"
            component={Select}
            options={options.interviewSources}
            disabled={!invited}
          />
          <Field
            name="interviewDetails.interviewDifficulty"
            label="The interview itself was"
            className="block"
            component={RadioLabels}
            options={options.interviewDifficulty}
            disabled={!invited}
          />
          <h6>Decision Details</h6>
          <Field
            name="interviewDetails.processLength"
            label="The time from submitting my application to being notified of a decision was"
            className="block"
            component={RadioLabels}
            options={options.decisionTime}
            disabled={editDisabled}
          />
          <Field
            name="interviewDetails.interviewOutcome"
            label="Did you get an offer?"
            className="block"
            component={RadioLabels}
            options={options.decisions}
            disabled={editDisabled}
          />
          <h6>Reviewer Information</h6>
          <Field
            name="reviewerDetails.serviceBranch"
            label="Service Branch"
            required
            className="block"
            component={RadioLabels}
            options={options.branchRange}
            validate={required}
            disabled={editDisabled}
          />
          {!isSpouse &&
            <Field
              label="Military Occupation"
              name="reviewerDetails.mos"
              placeholder="Select"
              component={Select}
              options={getMosOptions(serviceBranchValue)}
              disabled={editDisabled}
              {...(!isSpouse && {validate: required, required: true})}
            />
          }
          {!isSpouse &&
            <Field
              name="reviewerDetails.etsPaygrade"
              label="Highest Paygrade Attained"
              placeholder="Select"
              component={Select}
              options={options.paygradeOptions}
              disabled={editDisabled}
              {...(!isSpouse && {validate: required, required: true})}
            />
          }
          <Field
            name="reviewerDetails.email"
            label="Your E-mail"
            required
            placeholder="e.g. sgt.hooah@gmail.com or iam.t.standard4.mil@mail.mil"
            component={TextField}
            validate={required}
            disabled={editDisabled}
          />
          <h5 className="InterviewReview__agreement">{agreements.certifiedVet}</h5>
          {Object.keys(profile).length == 0 &&
            <Field
              name="captcha"
              component={Captcha}
              validate={required}
            />
          }
          {submitFailed && invalid &&
            <div className="ProgramReview__error">Please check if you filled all required fields.</div>
          }
          <button
            type="submit"
            className="btn-primary"
            disabled={pristine || submitting || invalid}
          >
            VET IT FORWARD!
          </button>
        </form>
      </div>
    )
  }
))